import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlus, faMinus} from '@fortawesome/free-solid-svg-icons';
import {ChangeEvent, useEffect, useState} from 'react';
import styles from './style.module.css';

export default function QuantityField(
  props: {
    classNames?: string;
    initialValue: number;
    minValue?: number;
    onValueChanged: (newValue: number) => void;
  } & {
    [key: string]: unknown;
  }
) {
  const {classNames, initialValue, minValue = 1, onValueChanged} = props;
  const [value, setValue] = useState<number>(initialValue ?? 1);

  let timeOutId: NodeJS.Timeout;
  const changeInputValue = (newValue: number) => {
    clearTimeout(timeOutId);
    setValue(newValue);
    if (onValueChanged) {
      timeOutId = setTimeout(() => {
        onValueChanged(newValue);
      }, 1000);
    }
  };
  const onInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = Number(event.target.value) || minValue;
    changeInputValue(newValue);
  };
  const decrementValue = () => {
    if (value <= minValue) {
      return;
    }
    changeInputValue(Number(value) - 1);
  };
  const incrementValue = () => {
    changeInputValue(Number(value) + 1);
  };
  const onInputLeave = () => {
    if (value < minValue) changeInputValue(minValue);
  };
  return (
    <div className={`${styles.quantityField} ${classNames}`}>
      <span onClick={decrementValue} className={`${styles.inputButton}`}>
        <FontAwesomeIcon icon={faMinus} />
      </span>
      <input
        onBlur={onInputLeave}
        onChange={onInputChange}
        value={value}
        type={'number'}
      />
      <span onClick={incrementValue} className={`${styles.inputButton}`}>
        <FontAwesomeIcon icon={faPlus} />
      </span>
    </div>
  );
}
